<script setup lang="ts">
  import { type UserTagType } from "~/entities/UserTagType";

  const localProps = defineProps<{
    modelValue: UserTagType[];
  }>();

  const emits = defineEmits(["update:modelValue"]);

  const localValue = computed<UserTagType[]>({
    get: () => localProps.modelValue,
    set: value => emits("update:modelValue", value),
  });

  const handleClear = () => {
    localValue.value = [];
  };

  const handleRemoveTagItem = (index: number) => {
    localValue.value = localValue.value.filter((_, idx) => idx !== index);
  };
</script>

<template>
  <div class="flex-grow-1 condition-selected-tags">
    <div class="d-flex align-center mb-2">
      <v-icon icon="$mdiTag" color="white" size="20" />
      <div class="flex-grow-1 px-2">選択済みタグ</div>
      <v-btn icon variant="outlined" color="white" size="20" @click="handleClear">
        <v-icon icon="$mdiClose" color="white" size="12" />
      </v-btn>
    </div>
    <v-divider></v-divider>
    <div class="d-flex ga-2 flex-wrap py-2" data-testid="selected-tag-items">
      <v-chip
        v-for="(tag, i) in localValue"
        :key="i"
        variant="flat"
        size="default"
        color="primary"
        class="chip-multiline"
        data-testid="selected-tag-item"
      >
        {{ tag.userTagName }}
        <v-icon
          icon="$mdiClose"
          color="primary"
          size="14"
          class="bg-white rounded-lg ml-2 cursor-pointer"
          @click="handleRemoveTagItem(i)"
        />
      </v-chip>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";
  .condition-selected-tags {
    padding: 8px;
    border: 1px solid rgba(var(--v-theme-monochrome-03), 1);
    border-radius: 5px;
    min-width: 350px;
    max-width: 400px;
  }
  .chip-multiline {
    min-height: 32px;
    height: auto;
    white-space: normal;
  }
</style>
